import { processThresholds } from "./alerts"
import { AlertConfigurationResponse } from "@/api/AlertConfigurationsService"
import icons from "@/assets/icons"
import { AlertSource } from "@/types/alert"
import {
   AlertConfiguration,
   AlertSystemConditionType,
} from "@/types/alertConfigurations"

export function formatAlertConfigurations(
   alertConfigurations: AlertConfigurationResponse[]
): AlertConfiguration[] {
   return alertConfigurations
      .sort((a, b) => a.priority - b.priority)
      .map(
         (alertConfiguration) =>
            formatAlertConfiguration(
               alertConfiguration
            ) as unknown as AlertConfiguration
      )
}

export function formatAlertConfiguration(
   alertConfiguration: AlertConfigurationResponse
): AlertConfiguration {
   return {
      id: alertConfiguration.id,
      priority: alertConfiguration.priority,
      name: alertConfiguration.name,
      colorCard: alertConfiguration.color.card.toLocaleLowerCase(),
      colorIcon: alertConfiguration.color.icon.toLocaleLowerCase(),
      colorTypeface: alertConfiguration.color.typeface.toLocaleLowerCase(),
      soundFrequency: alertConfiguration.sound.frequency,
      soundClip: alertConfiguration.sound.clip,
      ...processThresholds(alertConfiguration.thresholds),
      wearableType: alertConfiguration.sensorTypes?.includes(
         AlertSource.WEARABLE
      ),
      sensorType: alertConfiguration.sensorTypes?.includes(AlertSource.STATIC),
      order: alertConfiguration.priority,
      draggable: true,
      systemCondition: alertConfiguration.systemCondition,
      category: alertConfiguration.category,
      enabled: alertConfiguration.enabled ?? true,
      emailMessage: alertConfiguration.channels?.[0]
         ? {
              id: alertConfiguration.channels[0].id,
              emailMessageActivated: alertConfiguration.channels[0].active,
              recipients: alertConfiguration.channels[0].recipients,
           }
         : undefined,
   } as unknown as AlertConfiguration
}

export function getAlertSystemConditionTypeIconName(
   alertSystemConditionType: AlertSystemConditionType
): keyof typeof icons {
   switch (alertSystemConditionType) {
      case AlertSystemConditionType.NO_VITALS:
         return "noVitalSign"
      case AlertSystemConditionType.BROKEN_WEARABLE:
         return "brokenWatch"
      case AlertSystemConditionType.OUT_OF_BOUNDS:
      default:
         return "outOfBounds"
   }
}
